// Affiliate page (sections/qk-affiliate-landing.liquid): the creator rail's arrows, and its videos
// play only while they are on screen (muted, looping), so the page does not load them all at once.
(() => {
  for (const root of document.querySelectorAll('[data-qka]')) {
    const rail = root.querySelector('[data-qka-rail]');
    if (!rail) continue;
    const step = direction => rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: 'smooth' });
    root.querySelector('[data-qka-prev]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-qka-next]')?.addEventListener('click', () => step(1));
    const videos = rail.querySelectorAll('video[data-qka-video]');
    if (!videos.length) continue;
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) { videos.forEach(v => { v.preload = 'metadata'; }); continue; }
    const seen = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (video.preload === 'none') video.preload = 'auto';
          if (!still) video.play().catch(() => {});
        } else if (!video.paused) video.pause();
      }
    }, { threshold: [0, 0.5] });
    videos.forEach(v => { v.muted = true; v.playsInline = true; seen.observe(v); });
  }
})();
